import { render, staticRenderFns } from "./ImportPublication.vue?vue&type=template&id=c0dcd23e&scoped=true&"
import script from "./ImportPublication.vue?vue&type=script&lang=js&"
export * from "./ImportPublication.vue?vue&type=script&lang=js&"
import style0 from "./ImportPublication.vue?vue&type=style&index=0&id=c0dcd23e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dcd23e",
  null
  
)

export default component.exports